import { render } from "./ProductBoxBig.vue?vue&type=template&id=510d9132&scoped=true&ts=true"
import script from "./ProductBoxBig.vue?vue&type=script&lang=ts"
export * from "./ProductBoxBig.vue?vue&type=script&lang=ts"

import "./ProductBoxBig.vue?vue&type=style&index=0&id=510d9132&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510d9132"]])

export default __exports__